import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import { useTranslation } from 'react-i18next';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  NormalBlockWrapper,
  NormalTextBlock,
  TwoColumnWrapper,
  LeftColumn,
  RightColumn,
  ButtonsContainer,
  ImageContainer,
  RightTextBlock,
  NormalFilledButton,
  NormalHollowButton,
} from '../../styles/LongreadBlockRenderer.styles';
import { useGetCardCached } from '../../hooks';
import { getCardIdFromBlock } from '../../utils/blockUtils';
import { Lang } from '@brg/api';

interface NormalBlockProps {
  block: any;
  backgroundColor?: string;
  forceWhiteBackground?: boolean;
  padding?: string;
  paddingMobile?: string;
  stackOnMobile?: boolean;
}

export const NormalBlock: FC<NormalBlockProps> = ({ block, backgroundColor, forceWhiteBackground = false, padding, paddingMobile, stackOnMobile = false }) => {
  const { i18n } = useTranslation();
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];

  const cardId = useMemo(() => getCardIdFromBlock(block), [block]);
  const { card } = useGetCardCached(cardId || '', !cardId);

  const defaultTextColor = forceWhiteBackground ? '#151514' : '#FEFEFE';
  const wrapperBackground = forceWhiteBackground ? '#FEFEFE' : undefined;
  const textLength = block.text?.length || 0;

  const fontSize = useMemo(() => {
    const linesCount = block.text ? block.text.split('\n').length : 0;
    if (linesCount > 25) {
      return 17;
    }else if (textLength <= 1400) {
      return 26;
    } else if (textLength <= 2400) {
      return 19;
    }
    return 17;
  }, [textLength]);
  const hasImageOrCard = hasAttachments || (cardId && card?.images?.length > 0);

  const buttons = useMemo(() => {
    if (!block.buttons || !Array.isArray(block.buttons) || block.buttons.length === 0) {
      return null;
    }

    return block.buttons.map((button: any, index: number) => {
      const buttonTitle = Lang(button.title || [], i18n.language);
      if (!buttonTitle || !button.link) return null;

      const ButtonComponent = button.uprise === 1 ? NormalFilledButton : NormalHollowButton;

      return (
        <a
          key={button.id || index}
          href={button.link}
          target={button.type === 0 ? '_blank' : '_self'}
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          <ButtonComponent>
            {buttonTitle}
          </ButtonComponent>
        </a>
      );
    }).filter(Boolean);
  }, [block.buttons, i18n.language]);

  if (hasImageOrCard) {
    const imageFiles = cardId && card?.images?.length > 0 
      ? card.images 
      : files;
    
    return (
      <LongreadBlockWrapper $mobilePadding={paddingMobile}>
        <TwoColumnWrapper $background={wrapperBackground} $padding={padding} $mobilePadding={paddingMobile} $mobileColumn={stackOnMobile}>
          <LeftColumn>
            {imageFiles && imageFiles.length > 0 && (
              <ImageContainer>
                <ResizedImageEnhanced files={imageFiles} />
              </ImageContainer>
            )}
          </LeftColumn>
          <RightColumn>
            <RightTextBlock textColor={defaultTextColor} fontSize={fontSize} textLength={textLength}>
              {block.text && <FormatLinkedText text={block.text} />}
            </RightTextBlock>
            {buttons && buttons.length > 0 && (
              <ButtonsContainer>
                {buttons}
              </ButtonsContainer>
            )}
          </RightColumn>
        </TwoColumnWrapper>
      </LongreadBlockWrapper>
    );
  }

  return (
    <LongreadBlockWrapper $mobilePadding={paddingMobile}>
      <NormalBlockWrapper $background={wrapperBackground} $padding={padding} $mobilePadding={paddingMobile}>
        <NormalTextBlock textColor={defaultTextColor} fontSize={fontSize}>
          {block.text && <FormatLinkedText text={block.text} />}
        </NormalTextBlock>
        {buttons && buttons.length > 0 && (
          <ButtonsContainer>
            {buttons}
          </ButtonsContainer>
        )}
      </NormalBlockWrapper>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import { useTranslation } from 'react-i18next';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  NormalBlockWrapper,
  NormalTextBlock,
  TwoColumnWrapper,
  LeftColumn,
  RightColumn,
  ButtonsContainer,
  ImageContainer,
  RightTextBlock,
  NormalFilledButton,
  NormalHollowButton,
} from '../../styles/LongreadBlockRenderer.styles';
import { useGetCardCached } from '../../hooks';
import { getCardIdFromBlock } from '../../utils/blockUtils';
import { Lang } from '@brg/api';

interface NormalBlockProps {
  block: any;
  backgroundColor?: string;
  forceWhiteBackground?: boolean;
  padding?: string;
  paddingMobile?: string;
  stackOnMobile?: boolean;
}

export const NormalBlock: FC<NormalBlockProps> = ({ block, backgroundColor, forceWhiteBackground = false, padding, paddingMobile, stackOnMobile = false }) => {
  const { i18n } = useTranslation();
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];

  const cardId = useMemo(() => getCardIdFromBlock(block), [block]);
  const { card } = useGetCardCached(cardId || '', !cardId);

  const defaultTextColor = forceWhiteBackground ? '#151514' : '#FEFEFE';
  const wrapperBackground = forceWhiteBackground ? '#FEFEFE' : undefined;
  const textLength = block.text?.length || 0;

  const fontSize = useMemo(() => {
    const linesCount = block.text ? block.text.split('\n').length : 0;
    if (linesCount > 25) {
      return 17;
    }else if (textLength <= 1400) {
      return 26;
    } else if (textLength <= 2400) {
      return 19;
    }
    return 17;
  }, [textLength]);
  const hasImageOrCard = hasAttachments || (cardId && card?.images?.length > 0);

  const buttons = useMemo(() => {
    if (!block.buttons || !Array.isArray(block.buttons) || block.buttons.length === 0) {
      return null;
    }

    return block.buttons.map((button: any, index: number) => {
      const buttonTitle = Lang(button.title || [], i18n.language);
      if (!buttonTitle || !button.link) return null;

      const ButtonComponent = button.uprise === 1 ? NormalFilledButton : NormalHollowButton;

      return (
        <a
          key={button.id || index}
          href={button.link}
          target={button.type === 0 ? '_blank' : '_self'}
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          <ButtonComponent>
            {buttonTitle}
          </ButtonComponent>
        </a>
      );
    }).filter(Boolean);
  }, [block.buttons, i18n.language]);

  if (hasImageOrCard) {
    const imageFiles = cardId && card?.images?.length > 0 
      ? card.images 
      : files;
    
    return (
      <LongreadBlockWrapper $mobilePadding={paddingMobile}>
        <TwoColumnWrapper $background={wrapperBackground} $padding={padding} $mobilePadding={paddingMobile} $mobileColumn={stackOnMobile}>
          <LeftColumn>
            {imageFiles && imageFiles.length > 0 && (
              <ImageContainer>
                <ResizedImageEnhanced files={imageFiles} />
              </ImageContainer>
            )}
          </LeftColumn>
          <RightColumn>
            <RightTextBlock textColor={defaultTextColor} fontSize={fontSize} textLength={textLength}>
              {block.text && <FormatLinkedText text={block.text} />}
            </RightTextBlock>
            {buttons && buttons.length > 0 && (
              <ButtonsContainer>
                {buttons}
              </ButtonsContainer>
            )}
          </RightColumn>
        </TwoColumnWrapper>
      </LongreadBlockWrapper>
    );
  }

  return (
    <LongreadBlockWrapper $mobilePadding={paddingMobile}>
      <NormalBlockWrapper $background={wrapperBackground} $padding={padding} $mobilePadding={paddingMobile}>
        <NormalTextBlock textColor={defaultTextColor} fontSize={fontSize}>
          {block.text && <FormatLinkedText text={block.text} />}
        </NormalTextBlock>
        {buttons && buttons.length > 0 && (
          <ButtonsContainer>
            {buttons}
          </ButtonsContainer>
        )}
      </NormalBlockWrapper>
    </LongreadBlockWrapper>
  );
};
